import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { InstallPrompt } from "./components/InstallPrompt";
import { initSentry } from "./lib/sentry";
import { initPosthog } from "./lib/posthog";
import "./index.css";

initSentry();

// P4 — l'invitation à installer la PWA vit à CÔTÉ de <App /> : autonome, hors du
// routeur, elle décide seule de son affichage (tableau de bord uniquement, une fois
// `beforeinstallprompt` reçu) sans qu'aucune page ait à la connaître.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
    <InstallPrompt />
  </StrictMode>,
);

// LOT P4 — PostHog APRÈS le premier rendu et à l'idle : le SDK (~200 Ko) est chargé
// par import() dynamique et ne doit jamais concurrencer le bundle du portail.
// `initPosthog()` est un no-op complet hors production (cf. lib/posthog.ts).
if (typeof window.requestIdleCallback === "function") {
  window.requestIdleCallback(() => initPosthog());
} else {
  window.setTimeout(() => initPosthog(), 2000);
}
